
import { Options, Vue } from "vue-class-component";
import ProfilerService from "../../service/ProfilerService.js";
import Toaster from "../../helpers/Toaster";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import FileUploader from "../../components/FileUploader.vue";

@Options({
    title: "Profilers",
    components: {
        ProfilerDialog,
        FileUploader,
    },
})
export default class Profilers extends Vue {
    private lists = [];
    private keyword = "";
    private selectedAccountType = 0;
    private dialogTitle = "";
    private statusType = "New";
    private toast;
    private profilerID = 0;
    private currentUserID = 0;
    private goToFirstLink = 0;
    private profilerService;
    private checkPagination = true;
    private profileStatus = false;
    private statusDialog = false;
    private totalRecords = 0;
    private limit = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Initialization", to: "initialization" },
        { label: "Profilers", to: "profilers" },
    ];

    private item = {
        id: 0,
        accountTitle: "",
        status: "Active",
    };
    private accountTypes = [
        { key: 0, name:"All"},
        { key: 2, name:"Supplier"},
        { key: 1, name:"Customer"},
    ];

    private excelFileContent = [
        {
            accountTitle: "",
            emailAddress: "",
            contactNo: "",
            nationalID: "",
            address: "",
            accountType: "Customer",
            company: "",
            defaultExpiryAlertDuration: "",
            description: "",
            status: "",
        },
    ];
    private uploaderStatus = false;
    //CALLING WHEN PAGINATION BUTTON CLICKS
    onPage(event) {
        this.loadList(event.first);
    }

    //DEFAULT METHOD OF TYPE SCRIPT
    created() {
        this.profilerService = new ProfilerService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.loadList(0);
        // Add event listener for keypress
        window.addEventListener("keypress", this.handleKeypress);
    }

    beforeUnmount() {
        // Remove event listener
        window.removeEventListener("keypress", this.handleKeypress);
    }

    handleKeypress(event) {
        // Check for "Enter" key to detect the end of scanning
        if (event.key === "Enter") {
            this.loadList(this.goToFirstLink);
        } else {
        }
    }

    cleanSearchData() {
        this.keyword = "";
        this.goToFirstLink = 0;
        this.loadList(0);
    }

    openFileUploader() {
        this.uploaderStatus = true;
    }
    //OPEN DIALOG BOX FOR CONFIRMATION
    confirmChangeStatus(data) {
        this.item.id = data.id;
        this.item.accountTitle = data.account_title;
        this.statusDialog = true;
    }

    //CHANGE THE STATUS AND SEND HTTP TO SERVER
    changeStatus() {
        this.statusDialog = false;
        this.item.status = "Delete";
        this.profilerService.changeStatus(this.item).then((res) => {
            this.loadList(0);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
        });
    }

    //FETCH THE DATA FROM SERVER
    loadList(page) {
        this.profilerService.getItems(this.keyword, this.selectedAccountType, page).then((data) => {
            this.lists = data.records;
            this.totalRecords = data.totalRecords;
            this.limit = data.limit;
            this.currentUserID = data.currentUserID;
        });
    }

    loadSearchData() {
        if (this.keyword) {
            this.goToFirstLink = 0;
            this.loadList(0);
        }
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.dialogTitle = "Add New Profile";
        this.profileStatus = true;
        this.statusType = "New";
    }

    editIem(data) {
        this.statusType = "Update";
        this.profilerID = data.id;
        this.dialogTitle = "Update Profile";
        this.profileStatus = true;
        this.statusType = "Update";
    }

    updateProfilerStatus(res) {
        this.profileStatus = false;
        this.statusType = "New";

        if (res[0] == "load") {
            this.loadList(this.goToFirstLink);
        }
    }

    //OPEN DIALOG TO ADD NEW ITEM
    downloadSample() {
        this.profilerService.exportSampleStock().then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "sampleProfilersData.csv");
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    }

    updateUploaderStatus(params) {
        // //console.log("UPDATE UPLOADER STATUS FUNCTION LOADED vue");
        this.uploaderStatus = false;
        if (params.length > 0) {
            this.excelFileContent = [];

            this.profilerService.uploadCSVFile(params[0]).then((res) => {
                if (res.length > 0) {
                    res.forEach((e) => {
                        if (e[0] != "Profile Name (*) [Text]") {
                            this.excelFileContent.push({
                                accountTitle: e[0],
                                emailAddress: e[1],
                                contactNo: e[2],
                                nationalID: e[3],
                                address: e[4],
                                accountType: e[5],
                                company: e[6],
                                defaultExpiryAlertDuration: e[7],
                                description: e[8],
                                status: "Active",
                            });
                        }
                    });
                    ////console.log("excelfile content", this.excelFileContent);
                    this.saveFileData();
                    //console.log("Save excel file in update uploader status ", this.excelFileContent);
                }
            });
        }
    }

    saveFileData() {
        //console.log("Save excel file insavefle data function ", this.excelFileContent);
        this.profilerService.save(this.excelFileContent).then((res) => {
            this.clearAll();
            this.toast.handleResponse(res);
            this.loadList(0);
        });
    }

    clearAll() {
        this.excelFileContent = [];
        this.toast.showSuccess("Cleared Successfully");
    }
}
